import { Controller } from "@hotwired/stimulus"

// Auto-dismisses flash messages after 5 seconds.
// Connects to data-controller="flash" on each flash toast element.
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    this.element.style.opacity = "0"
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
